import logo from '../assets/images/logo.svg'
import wideLogo from '../assets/images/logo.svg'
const Logo = ({height,imageType}) => (
    <img
        src={imageType=='wide'?wideLogo:logo}
        alt="Shoqa Logo"
        className={`logo ${imageType=='wide' && "wide-logo"}`}    />
)
export default Logo
